import { frontendURL } from '../../../../helper/URLHelper';

const contactViews = accountId => ({
  parentNav: 'contact_views',
  routes: [
    'home_contact_views',
    'inbox_dashboard_contact_views',
    'conversation_through_inbox_contact_views',
    'inbox_contact_views',
    'inbox_contact_views_conversation',
    'conversation_through_inbox',
    'notifications_dashboard',
    'label_contact_views',
    'label_contacts_contact_views',
    'conversations_through_label_contact_views',
    'conversations_through_label',
    'team_contact_views',
    'team_contacts_contact_views',
    'conversations_through_team_contact_views',
    'conversations_through_team',
    'conversation_mentions_contact_views',
    'conversation_through_mentions',
    'conversation_participating',
    'conversation_through_participating',
    'folder_contacts_contact_views',
    'conversations_through_folders_contact_views',
    'conversations_through_folders',
    'conversation_unattended_contact_views',
    'conversation_through_unattended',
  ],
  menuItems: [
    {
      icon: 'chat',
      label: 'ALL_CONTACT_VIEWS',
      key: 'conversations',
      toState: frontendURL(`accounts/${accountId}/contact-views`),
      toolTip: 'Conversation from all subscribed inboxes',
      toStateName: 'home_contact_views',
    },
    /*
    {
      icon: 'mention',
      label: 'MENTIONED_CONVERSATIONS',
      key: 'conversation_mentions_contact_views',
      toState: frontendURL(`accounts/${accountId}/mentions/contact-views`),
      toStateName: 'conversation_mentions_contact_views',
    },
    {
      icon: 'mail-unread',
      label: 'UNATTENDED_CONVERSATIONS',
      key: 'conversation_unattended_contact_views',
      toState: frontendURL(`accounts/${accountId}/unattended/contact-views`),
      toStateName: 'conversation_unattended_contact_views',
    },*/
  ],
});

export default contactViews;
